import BasicRouter from './router/router'

function App() {
  return (
    <BasicRouter />
  );
}

export default App;